const INVALID_SESSION_ERROR_CODES = new Set([
  "login_required",
  "consent_required",
  "invalid_grant",
  "missing_refresh_token",
  "invalid_refresh_token",
]);

export const logoutToHome = (logout) => {
  logout({
    logoutParams: {
      returnTo: window.location.origin,
    },
  });
};

export const isSessionInvalidError = (error) => {
  const code = error?.error || error?.code || "";
  if (INVALID_SESSION_ERROR_CODES.has(code)) {
    return true;
  }

  const message = String(error?.message || "").toLowerCase();
  return (
    message.includes("login required") ||
    message.includes("missing refresh token") ||
    message.includes("invalid refresh token") ||
    message.includes("invalid_grant") ||
    message.includes("failed to refresh token")
  );
};
